import { InjectionToken } from '@angular/core';

import { PrypcoEnv } from '../models/prypco-env.model';

export const ENV = new InjectionToken<PrypcoEnv>('PRYPCO_ENVIRONMENT');
